import { createFileRoute } from '@tanstack/react-router';

// The lists alone, with no sitemap node open
export const Route = createFileRoute('/_authenticated/sitemaps/$tenantId/')({});
